<!--
 * @Descripttion: 
 * @version: 
 * @Author: xzx
 * @Date: 2021-01-12 17:37:18
 * @LastEditors: xzx
 * @LastEditTime: 2021-01-14 13:40:20
-->
<template>
    <div :class="{'block-drop-shadow': shadow}" :style="{position: 'absolute', width: '520px', height: '320px', backgroundColor: bgColor, opacity: opacity,borderRadius: `${borderRadius}px`}">
    </div>
</template>

<script>
export default {
    name: "tw-ws-block",
    props: {
        bgColor: {
            type: String,
            default: '#000000'
        },
        opacity: {
            type: Number,
            default: 0.7
        },
        borderRadius: {
            type: Number,
            default: 0
        },
        shadow: {
            type: Boolean,
            default: true
        }
    },
    setup(){

    }
}
</script>

<style>

</style>
